import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
} from "reactstrap";
import AppModal from "../../Common/AppModal";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewSingleCustomer,
  createSingleCustomerSuccess,
  getCustomersListData,
  getCustomerStatusListData,
  getCustomerTypeListData,
  getSingleCustomersData,
  updateSingleCustomer,
  updateSingleCustomerSuccess,
} from "../../../store/customers/action";

import { getPaymentTermsList } from "../../../store/paymentTerm/action";
import "./createEditCustomer.scss";
import classnames from "classnames";
import { TabStepABusinessNameAndAddress } from "./tabStepABusinessNameAndAddress";
import { TabStepBBusinessContactInformation } from "./tabStepBBusinessContactInformation";
import { useHistory } from "react-router-dom";
import { getAcquisitionChannelList } from "../../../store/customerAcquisitionChannel/action";
import { TabAcquisitionChannel } from "./tabAcquisitionChannel";
import {
  TabPeople,
  wizardPersonHasName,
  wizardPersonPayload,
} from "./tabPeople";
import { createContactPersonApiCall } from "../../../helpers/fakebackend_helper";
import { getInvoicePaymentMethodList } from "../../../store/invoiceCrmIT/action";
import LoadingSpinner from "../../Common/Spinner";

export default function CreateEditCustomer({
  modalCreateCustomer,
  setModalCreateCustomer,
  toggleCreateCustomer,
  setIsEditCustomer,
  isEditCustomer,
  singleCustomerData,
  // Change #100150 - optional. When a host popup (e.g. Create New Opportunity)
  // opens this to add a customer on the fly, it passes this and gets the new
  // customer_data back to select it. "Create & Open" would navigate away from
  // the host's half-filled form, so the button becomes "Create & Select" and
  // the Create Only / Create and Open menu is not offered.
  onCustomerCreated,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { paymentTermsList } = useSelector((state) => ({
    paymentTermsList: state.PaymentTerm.paymentTermsList?.paymentterm_list,
  }));
  const { PaymentMethodListAPI } = useSelector((state) => ({
    PaymentMethodListAPI:
      state.InvoiceCrmIT.invoicePaymentMethodList?.paymentmethod_list,
  }));
  const { acquisitionChannelListAPI } = useSelector((state) => ({
    acquisitionChannelListAPI:
      state.CustomerAcquisitionChannel?.acquisitionChannelList
        ?.customeracquisitionchannel_list,
  }));
  useEffect(() => {
    dispatch(getPaymentTermsList());
    dispatch(getAcquisitionChannelList());
    dispatch(getCustomerStatusListData());
    dispatch(getCustomerTypeListData());
    dispatch(getInvoicePaymentMethodList());
  }, []);

  const initialData = {
    CustomerBusinessType_Id: "",
    BusinessName: "",
    PersonTitle: "",
    PersonFirstName: "",
    PersonLastName: "",
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    PaymentTerm_Id: "",
    PaymentMethod_Id: "",
    RegNo: "",
    CustomerAcquisitionChannel_Id: "",
    FlagDisableInvoice: "0",
    FlagDisableProformaInvoice: "0",
    FlagProformaInvoiceRequiredBeforeInvoice: "0",
    contactemailaddress_data: [
      {
        ContactEmailAddress_Id: 1,
        EmailAddress: "",
        FlagEmailInvoiceTo: 0,
        FlagEmailInvoiceCc: 0,
        FlagEmailProformaInvoiceTo: 0,
        FlagEmailProformaInvoiceCc: 0,
      },
    ],
    contacttelephonenumber_data: [
      {
        ContactTelephoneNumber_Id: 1,
        TelephoneNumber: "",
      },
    ],
    Notes: "",
    InvoiceFreeText1: "",
    ProformaInvoiceFreeText1: "",
    FlagSendAccountStatement: "0",
    SendAccountStatementDayNo: "",
  };
  const [customerDetails, setCustomerDetails] = useState(initialData);

  useEffect(() => {
    if (!isEditCustomer) return;
    if (isEmpty(singleCustomerData)) return;
    setCustomerDetails({
      Id: singleCustomerData?.customer_data?.Id,
      CustomerBusinessType_Id:
        singleCustomerData?.customer_data?.CustomerBusinessType_Id,
      BusinessName: singleCustomerData?.customer_data?.BusinessName,
      PersonTitle: singleCustomerData?.customer_data?.PersonTitle,
      PersonFirstName: singleCustomerData?.customer_data?.PersonFirstName,
      PersonLastName: singleCustomerData?.customer_data?.PersonLastName,
      AddressLine1: singleCustomerData?.customer_data?.AddressLine1,
      AddressLine2: singleCustomerData?.customer_data?.AddressLine2,
      AddressLine3: singleCustomerData?.customer_data?.AddressLine3,
      AddressLine4: singleCustomerData?.customer_data?.AddressLine4,
      AddressCity: singleCustomerData?.customer_data?.AddressCity,
      AddressCounty: singleCustomerData?.customer_data?.AddressCounty,
      AddressPostCode: singleCustomerData?.customer_data?.AddressPostCode,
      AddressCountry: singleCustomerData?.customer_data?.AddressCountry,
      PaymentTerm_Id: singleCustomerData?.customer_data?.PaymentTerm_Id,
      PaymentMethod_Id: singleCustomerData?.customer_data?.PaymentMethod_Id,
      RegNo: singleCustomerData?.customer_data?.RegNo,
      CustomerAcquisitionChannel_Id:
        singleCustomerData?.customer_data?.CustomerAcquisitionChannel_Id,
      FlagDisableInvoice: singleCustomerData?.customer_data?.FlagDisableInvoice,
      FlagDisableProformaInvoice:
        singleCustomerData?.customer_data?.FlagDisableProformaInvoice,
      FlagProformaInvoiceRequiredBeforeInvoice:
        singleCustomerData?.customer_data
          ?.FlagProformaInvoiceRequiredBeforeInvoice,
      contactemailaddress_data:
        singleCustomerData?.contactemailaddress_data?.map((item) => {
          return {
            ContactEmailAddress_Id: item.ContactEmailAddress_Id,
            EmailAddress: item.ContactEmailAddress_EmailAddress,
            FlagEmailInvoiceTo:
              item.CustomerToContactEmailAddressRelationship_FlagEmailInvoiceTo,
            FlagEmailInvoiceCc:
              item.CustomerToContactEmailAddressRelationship_FlagEmailInvoiceCc,
            FlagEmailProformaInvoiceTo:
              item.CustomerToContactEmailAddressRelationship_FlagEmailProformaInvoiceTo,
            FlagEmailProformaInvoiceCc:
              item.CustomerToContactEmailAddressRelationship_FlagEmailProformaInvoiceCc,
          };
        }),
      contacttelephonenumber_data:
        singleCustomerData?.contacttelephonenumber_data?.map((item) => {
          return {
            ContactTelephoneNumber_Id: item?.ContactTelephoneNumber_Id,
            TelephoneNumber: item?.ContactTelephoneNumber_TelephoneNumber,
          };
        }),
      Notes: singleCustomerData?.customer_data?.Notes,
      InvoiceFreeText1: singleCustomerData?.customer_data?.InvoiceFreeText1,
      ProformaInvoiceFreeText1:
        singleCustomerData?.customer_data?.ProformaInvoiceFreeText1,
      FlagSendAccountStatement:
        singleCustomerData?.customer_data?.FlagSendAccountStatement,
      SendAccountStatementDayNo:
        singleCustomerData?.customer_data?.SendAccountStatementDayNo,
    });
  }, [singleCustomerData]);

  // Access Redux State
  const {
    createCustomerValidationResponse,
    updateCustomerValidationResponse,
    loading,
  } = useSelector((state) => ({
    createCustomerValidationResponse:
      state.Customers.createSingleCustomerResponse,
    updateCustomerValidationResponse:
      state.Customers.singleCustomerDataUpdateSuccess,
    loading: state.Customers.loading,
  }));
  const [createAndStayOrView, setCreateAndStayOrView] = useState("");
  // Change #100301 - people typed into the People step. Kept out of
  // customerDetails so the customer create payload is unchanged.
  const [wizardPeople, setWizardPeople] = useState([]);
  const [creatingPeople, setCreatingPeople] = useState(false);

  // One contactperson/create per person, as the People tab does - the
  // endpoint's default email/phone bookkeeping is not reset between rows of
  // one array. Awaited so "Create & Open" lands on a People tab that has them.
  const createWizardPeople = async (Customer_Id) => {
    const people = wizardPeople.filter(wizardPersonHasName);
    if (!Customer_Id || people.length === 0) return;
    setCreatingPeople(true);
    const failed = [];
    for (const person of people) {
      try {
        const res = await createContactPersonApiCall([
          wizardPersonPayload(person, Customer_Id),
        ]);
        if (res?.status !== 200) failed.push(person);
      } catch (e) {
        failed.push(person);
      }
    }
    setCreatingPeople(false);
    if (failed.length) {
      toast.error(
        `Customer created, but ${failed.length} of ${people.length} people could not be added: ${failed
          .map((p) => `${p.FirstName} ${p.LastName}`.trim())
          .join(", ")}. Add them from the People tab.`
      );
    }
  };

  const handleCheckEachStep = (VerticalTab) => {
    // Step A
    if (customerDetails.CustomerBusinessType_Id === "") {
      toast.error("Please select business type");
      return;
    }

    if (customerDetails.CustomerBusinessType_Id === "1") {
      if (isEmpty(customerDetails.BusinessName)) {
        toast.error("Please enter business name");
        return;
      }
      // First Line

      //Payment terms
      if (isEmpty(customerDetails.PaymentTerm_Id)) {
        toast.error("Please select payment terms");
        return;
      }
    }
    if (customerDetails.CustomerBusinessType_Id === "2") {
      if (isEmpty(customerDetails.PersonFirstName)) {
        toast.error("Please enter first name");
        return;
      }
      if (isEmpty(customerDetails.PersonLastName)) {
        toast.error("Please enter last name");
        return;
      }

      //Payment terms
      if (isEmpty(customerDetails.PaymentTerm_Id)) {
        toast.error("Please select payment terms");
        return;
      }
    }
    toggleVerticalTab(VerticalTab);
  };

  // Handle Create Customer
  const handleCreateCustomer = (view) => {
    if (view === "view") {
      setCreateAndStayOrView("view");
    }
    if (customerDetails.CustomerBusinessType_Id === "1") {
      if (isEmpty(customerDetails.BusinessName)) {
        toast.error("Please enter business name");
        return;
      }
    }
    if (customerDetails.CustomerBusinessType_Id === "2") {
      if (isEmpty(customerDetails.PersonFirstName)) {
        toast.error("Please enter first name");
        return;
      }
      if (isEmpty(customerDetails.PersonLastName)) {
        toast.error("Please enter last name");
        return;
      }
    }
    const sendData = [customerDetails];
    dispatch(createNewSingleCustomer(sendData));
  };
  // handle Edit Update Customer
  const handleEditCustomer = () => {
    // TODO: Update Customer
    const sendData = [customerDetails];
    dispatch(updateSingleCustomer(sendData));
  };

  //Update Customer Validation response handler
  useEffect(() => {
    if (isEmpty(updateCustomerValidationResponse)) return;
    if (updateCustomerValidationResponse.status === 200) {
      dispatch(getCustomersListData());
      dispatch(
        getSingleCustomersData({ id: singleCustomerData.customer_data.Id })
      );

      toast.success(updateCustomerValidationResponse.message);
      setModalCreateCustomer(false);
      // reset customer details object to default
      setCustomerDetails(initialData);
    } else {
      toast.error(updateCustomerValidationResponse.message);
    }
    dispatch(updateSingleCustomerSuccess([]));
  }, [updateCustomerValidationResponse]);
  // Create Customer Validation response handler

  const handleCustomerCreated = async (response) => {
    // Change #100301 - the people from the People step, against the new id,
    // before the popup closes or navigates.
    await createWizardPeople(response?.customer_data?.Id);
    setWizardPeople([]);
    if (createAndStayOrView === "view") {
      history.push(`/customer-single/${response?.customer_data?.Id}/view`);
      setModalCreateCustomer(false);
      toast.success(response.message);
    } else {
      dispatch(getCustomersListData());
      // create returns only { Id, ExternalId }, so the details just typed
      // go back too - the host can show the name before its list reloads.
      onCustomerCreated?.(response?.customer_data, customerDetails);
      setModalCreateCustomer(false);
      toast.success(response.message);
    }
    // reset customer details object to default
    setCustomerDetails(initialData);
  };

  useEffect(() => {
    if (isEmpty(createCustomerValidationResponse)) return;
    if (createCustomerValidationResponse.status === 200) {
      handleCustomerCreated(createCustomerValidationResponse);
    } else {
      toast.error(createCustomerValidationResponse.message);
    }
    dispatch(createSingleCustomerSuccess([]));
  }, [createCustomerValidationResponse]);

  const [activeVerticalTab, setactiveVerticalTab] = useState(1);
  const [passedverticalSteps, setPassedverticalSteps] = useState([1]);

  function toggleVerticalTab(tab) {
    if (activeVerticalTab !== tab) {
      var modifiedSteps = [...passedverticalSteps, tab];
      setactiveVerticalTab(tab);
      setPassedverticalSteps(modifiedSteps);
    }
  }
  const handleAddEmailRow = () => {
    const { contactemailaddress_data } = customerDetails;
    const newEmailRow = {
      // get last id and add 1
      // check if property ContactEmailAddress_Id exists if not then set it to 1
      ContactEmailAddress_Id: contactemailaddress_data[
        contactemailaddress_data.length - 1
      ]?.ContactEmailAddress_Id
        ? contactemailaddress_data[contactemailaddress_data.length - 1]
            ?.ContactEmailAddress_Id + 1
        : 1,

      EmailAddress: "",
      FlagEmailInvoiceTo: 0,
      FlagEmailInvoiceCc: 0,
      FlagEmailProformaInvoiceTo: 0,
      FlagEmailProformaInvoiceCc: 0,
    };
    setCustomerDetails({
      ...customerDetails,
      contactemailaddress_data: [...contactemailaddress_data, newEmailRow],
    });
  };
  const handleAddPhoneRow = () => {
    const { contacttelephonenumber_data } = customerDetails;
    const newPhoneRow = {
      // get last id and add 1
      // check if property ContactTelephoneNumber_Id exists if not then set it to 1

      ContactTelephoneNumber_Id: contacttelephonenumber_data[
        contacttelephonenumber_data.length - 1
      ]?.ContactTelephoneNumber_Id
        ? contacttelephonenumber_data[contacttelephonenumber_data.length - 1]
            ?.ContactTelephoneNumber_Id + 1
        : 1,
      TelephoneNumber: "",
    };
    setCustomerDetails({
      ...customerDetails,
      contacttelephonenumber_data: [
        ...contacttelephonenumber_data,
        newPhoneRow,
      ],
    });
  };
  const handleRemoveEmailRow = (id) => {
    const { contactemailaddress_data } = customerDetails;
    const newEmailRow = contactemailaddress_data?.filter(
      (item) => item.ContactEmailAddress_Id !== id
    );
    setCustomerDetails({
      ...customerDetails,
      contactemailaddress_data: newEmailRow,
    });
  };
  const handleRemovePhoneRow = (id) => {
    const { contacttelephonenumber_data } = customerDetails;
    const newPhoneRow = contacttelephonenumber_data?.filter(
      (item) => item.ContactTelephoneNumber_Id !== id
    );

    setCustomerDetails({
      ...customerDetails,
      contacttelephonenumber_data: newPhoneRow,
    });
  };

  return (
    <>
      <AppModal
        open={modalCreateCustomer}
        onClose={() => {
          setModalCreateCustomer(false);
          // check if setIsEditCustomer prop valid function then set it to false
          if (setIsEditCustomer) {
            setIsEditCustomer(false);
          }
        }}
        title={
          isEditCustomer ? (
            <>
              Editing Customer #{customerDetails?.Id}{" "}
              {customerDetails?.FullName}
            </>
          ) : (
            <>
              Create Customer{" "}
              {customerDetails?.BusinessName
                ? customerDetails?.BusinessName
                : customerDetails?.PersonFirstName +
                  " " +
                  customerDetails?.PersonLastName}
            </>
          )
        }
        icon={<PersonOutlineOutlinedIcon />}
        headerAccent="indigo"
        size="lg"
        hideFooter
      >
          {" "}
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="form-steps">
                  <form className="vertical-navs-step">
                    <Row className="gy-5">
                      <Col lg={3}>
                        <Nav className="flex-column custom-nav nav-pills">
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 1,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab > 1,
                              })}
                              onClick={() => {
                                handleCheckEachStep(1);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 1
                              </span>
                              Name & Address
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 2,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 2,
                              })}
                              onClick={() => {
                                handleCheckEachStep(2);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 2
                              </span>
                              Contact Information
                            </NavLink>
                          </NavItem>

                          {/* Change #100301 */}
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 3,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 3,
                              })}
                              onClick={() => {
                                handleCheckEachStep(3);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 3
                              </span>
                              People
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 4,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 4,
                              })}
                              onClick={() => {
                                handleCheckEachStep(4);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 4
                              </span>
                              Acquisition Channel
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 5,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 6,
                              })}
                              onClick={() => {
                                handleCheckEachStep(5);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 5
                              </span>
                              Additional Information
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 6,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 6,
                              })}
                              onClick={() => {
                                handleCheckEachStep(6);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 6
                              </span>
                              Finish
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                      <Col lg={9}>
                        <div className="px-lg-4">
                          <TabContent activeTab={activeVerticalTab}>
                            <TabPane tabId={1}>
                              <TabStepABusinessNameAndAddress
                                customerDetails={customerDetails}
                                setCustomerDetails={setCustomerDetails}
                                paymentTermsList={paymentTermsList}
                                PaymentMethodListAPI={PaymentMethodListAPI}
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                                handleCheckEachStep={handleCheckEachStep}
                              />
                            </TabPane>

                            <TabPane tabId={2}>
                              <TabStepBBusinessContactInformation
                                customerDetails={customerDetails}
                                setCustomerDetails={setCustomerDetails}
                                handleRemoveEmailRow={handleRemoveEmailRow}
                                handleAddEmailRow={handleAddEmailRow}
                                handleRemovePhoneRow={handleRemovePhoneRow}
                                handleAddPhoneRow={handleAddPhoneRow}
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                                handleCheckEachStep={handleCheckEachStep}
                              />
                            </TabPane>
                            {/* Change #100301 */}
                            <TabPane tabId={3}>
                              <TabPeople
                                activeVerticalTab={activeVerticalTab}
                                handleCheckEachStep={handleCheckEachStep}
                                isEditCustomer={isEditCustomer}
                                wizardPeople={wizardPeople}
                                setWizardPeople={setWizardPeople}
                              />
                            </TabPane>
                            <TabPane tabId={4}>
                              <TabAcquisitionChannel
                                customerDetails={customerDetails}
                                setCustomerDetails={setCustomerDetails}
                                handleRemoveEmailRow={handleRemoveEmailRow}
                                handleAddEmailRow={handleAddEmailRow}
                                handleRemovePhoneRow={handleRemovePhoneRow}
                                handleAddPhoneRow={handleAddPhoneRow}
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                                handleCheckEachStep={handleCheckEachStep}
                                acquisitionChannelListAPI={
                                  acquisitionChannelListAPI
                                }
                              />
                            </TabPane>

                            <TabPane tabId={5}>
                              <div>
                                <h5>Additional Information</h5>
                              </div>
                              <div>
                                <Label>Invoice Free Text 1 </Label>
                                <div>
                                  <textarea
                                    className="form-control"
                                    rows="3"
                                    value={customerDetails?.InvoiceFreeText1}
                                    onChange={(e) => {
                                      setCustomerDetails({
                                        ...customerDetails,
                                        InvoiceFreeText1: e.target.value,
                                      });
                                    }}
                                  ></textarea>
                                </div>
                                <div>
                                  <Label>Proforma Invoice Free Text 1 </Label>
                                  <div>
                                    <textarea
                                      className="form-control"
                                      rows="3"
                                      value={
                                        customerDetails?.ProformaInvoiceFreeText1
                                      }
                                      onChange={(e) => {
                                        setCustomerDetails({
                                          ...customerDetails,
                                          ProformaInvoiceFreeText1:
                                            e.target.value,
                                        });
                                      }}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              <div className={"mt-2"}>
                                {/*  allow to auto send FlagSendAccountStatement*/}
                                <input
                                  type="checkbox"
                                  className="form-check-input me-2"
                                  id="FlagSendAccountStatement"
                                  checked={
                                    customerDetails?.FlagSendAccountStatement ===
                                    "1"
                                  }
                                  onChange={(e) => {
                                    setCustomerDetails({
                                      ...customerDetails,
                                      FlagSendAccountStatement: e.target.checked
                                        ? "1"
                                        : "0",
                                    });
                                  }}
                                />
                                <span>
                                  Send Customer Statement Automatically
                                </span>
                              </div>
                              {customerDetails?.FlagSendAccountStatement ===
                                "1" && (
                                <div className={"mt-2"}>
                                  <Label>
                                    Day of the Month to Send Statement
                                  </Label>
                                  <select
                                    className="form-select"
                                    value={
                                      +customerDetails?.SendAccountStatementDayNo
                                    }
                                    onChange={(e) => {
                                      setCustomerDetails({
                                        ...customerDetails,
                                        SendAccountStatementDayNo:
                                          e.target.value,
                                      });
                                    }}
                                  >
                                    <option value="">Select Day</option>
                                    {Array.from({ length: 28 }, (_, i) => (
                                      <option key={i} value={i + 1}>
                                        {i + 1}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                              <div className="d-flex align-items-start gap-3 mt-4">
                                <button
                                  type="button"
                                  className="btn btn-light btn-label previestab"
                                  onClick={() => {
                                    handleCheckEachStep(activeVerticalTab - 1);
                                  }}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                                  Additional Information
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-success btn-label right ms-auto nexttab"
                                  onClick={() => {
                                    handleCheckEachStep(activeVerticalTab + 1);
                                  }}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                  Finish
                                </button>
                              </div>
                            </TabPane>
                            <TabPane tabId={6}>
                              <div>
                                <div>
                                  {isEditCustomer ? (
                                    <>
                                      <span className={"h6"}>
                                        Editing Customer Summary
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <span className={"h6"}>
                                        Creating Customer Summary
                                      </span>
                                    </>
                                  )}
                                </div>
                                <Card className={"p-2"}>
                                  <div className={"pt-2"}>
                                    <span>
                                      {customerDetails?.CustomerBusinessType_Id ===
                                      "1"
                                        ? "Business"
                                        : "Person"}{" "}
                                      Name & Address
                                    </span>
                                  </div>
                                  {/*add line*/}
                                  <hr />
                                  <Row>
                                    {customerDetails?.CustomerBusinessType_Id ===
                                    "2" ? (
                                      <div>
                                        <Col lg={4}>
                                          <div>
                                            <span className={"fw-bold"}>
                                              Title:{" "}
                                            </span>
                                            {customerDetails?.PersonTitle}
                                          </div>
                                        </Col>

                                        <Col lg={4}>
                                          <div>
                                            <span className={"fw-bold"}>
                                              First Name:{" "}
                                            </span>

                                            {customerDetails?.PersonFirstName}
                                          </div>
                                        </Col>
                                        <Col lg={4}>
                                          <div>
                                            <span className={"fw-bold"}>
                                              Last Name:{" "}
                                            </span>

                                            {customerDetails?.PersonLastName}
                                          </div>
                                        </Col>
                                      </div>
                                    ) : (
                                      <Col lg={12}>
                                        <div>
                                          <span className={"fw-bold"}>
                                            Business Name:{" "}
                                          </span>

                                          {customerDetails?.BusinessName}
                                        </div>
                                      </Col>
                                    )}
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine1}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine2}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine3}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine4}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          City:{" "}
                                        </span>
                                        {customerDetails?.AddressCity}
                                      </div>
                                    </Col>

                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          County:{" "}
                                        </span>
                                        {customerDetails?.AddressCounty}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Postcode:{" "}
                                        </span>

                                        {customerDetails?.AddressPostCode}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Country:{" "}
                                        </span>

                                        {customerDetails?.AddressCountry}
                                      </div>
                                    </Col>

                                    <Col lg={12}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Payment Term:{" "}
                                        </span>

                                        {
                                          paymentTermsList?.find(
                                            (item) =>
                                              item.Id ===
                                              customerDetails?.PaymentTerm_Id
                                          )?.Name
                                        }
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Payment Method:{" "}
                                          <span className={"text-danger"}>
                                            *
                                          </span>
                                        </span>

                                        {
                                          PaymentMethodListAPI?.find(
                                            (item) =>
                                              item.Id ===
                                              customerDetails?.PaymentMethod_Id
                                          )?.Name
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </Card>
                                <hr />
                                <Card className={"p-2"}>
                                  <div className={"pt-2"}>
                                    <span>Step - Contact Information</span>
                                  </div>
                                  <hr />
                                  <div>
                                    <Row>
                                      <Col lg={6}>
                                        <div>
                                          {" "}
                                          <span className={"fw-bold"}>
                                            Email List:{" "}
                                          </span>{" "}
                                        </div>
                                        <div>
                                          {!isEmpty(
                                            customerDetails
                                              ?.contactemailaddress_data[0]
                                              ?.EmailAddress
                                          ) ? (
                                            <>
                                              {" "}
                                              {customerDetails.contactemailaddress_data?.map(
                                                (item, index) => {
                                                  return (
                                                    <div
                                                      className={
                                                        "d-flex flex-row p-1"
                                                      }
                                                      key={index}
                                                    >
                                                      <div>
                                                        <div>
                                                          <span
                                                            className={"me-2"}
                                                          >
                                                            Invoicing
                                                          </span>
                                                          <span
                                                            className={
                                                              "btn m-0 p-0"
                                                            }
                                                            // toggle "1" or "0" on click
                                                            onClick={() => {
                                                              if (
                                                                item.FlagEmailInvoiceTo ===
                                                                "1"
                                                              ) {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailInvoiceTo =
                                                                  "0";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              } else {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailInvoiceTo =
                                                                  "1";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {" "}
                                                            To:{" "}
                                                            {item.FlagEmailInvoiceTo ===
                                                            "1" ? (
                                                              <i className="fa-regular fa-circle-check text-success"></i>
                                                            ) : (
                                                              <i className="fa-regular fa-circle-xmark text-danger"></i>
                                                            )}{" "}
                                                          </span>
                                                          <span
                                                            className={
                                                              "btn m-0 p-0 ms-1"
                                                            }
                                                            // toggle 1 or 0 on click
                                                            onClick={() => {
                                                              if (
                                                                item.FlagEmailInvoiceCc ===
                                                                "1"
                                                              ) {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailInvoiceCc =
                                                                  "0";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              } else {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailInvoiceCc =
                                                                  "1";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {" "}
                                                            Cc:{" "}
                                                            {item.FlagEmailInvoiceCc ===
                                                            "1" ? (
                                                              <i className="fa-regular fa-circle-check text-success"></i>
                                                            ) : (
                                                              <i className="fa-regular fa-circle-xmark text-danger"></i>
                                                            )}
                                                          </span>
                                                          {/*  Proforma*/}
                                                        </div>{" "}
                                                        <div>
                                                          <span
                                                            className={"me-2"}
                                                          >
                                                            Proforma Invoicing
                                                          </span>
                                                          <span
                                                            className={
                                                              "btn m-0 p-0"
                                                            }
                                                            // toggle "1" or "0" on click
                                                            onClick={() => {
                                                              if (
                                                                item.FlagEmailProformaInvoiceTo ===
                                                                "1"
                                                              ) {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailProformaInvoiceTo =
                                                                  "0";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              } else {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailProformaInvoiceTo =
                                                                  "1";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {" "}
                                                            To:{" "}
                                                            {item.FlagEmailProformaInvoiceTo ===
                                                            "1" ? (
                                                              <i className="fa-regular fa-circle-check text-success"></i>
                                                            ) : (
                                                              <i className="fa-regular fa-circle-xmark text-danger"></i>
                                                            )}{" "}
                                                          </span>
                                                          <span
                                                            className={
                                                              "btn m-0 p-0 ms-1"
                                                            }
                                                            // toggle 1 or 0 on click
                                                            onClick={() => {
                                                              if (
                                                                item.FlagEmailProformaInvoiceCc ===
                                                                "1"
                                                              ) {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailProformaInvoiceCc =
                                                                  "0";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              } else {
                                                                let temp =
                                                                  customerDetails.contactemailaddress_data;
                                                                temp[
                                                                  index
                                                                ].FlagEmailProformaInvoiceCc =
                                                                  "1";
                                                                setCustomerDetails(
                                                                  {
                                                                    ...customerDetails,
                                                                    contactemailaddress_data:
                                                                      temp,
                                                                  }
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {" "}
                                                            Cc:{" "}
                                                            {item.FlagEmailProformaInvoiceCc ===
                                                            "1" ? (
                                                              <i className="fa-regular fa-circle-check text-success"></i>
                                                            ) : (
                                                              <i className="fa-regular fa-circle-xmark text-danger"></i>
                                                            )}
                                                          </span>
                                                          {/*  Proforma*/}
                                                        </div>
                                                        <div className={"p-1"}>
                                                          {item.EmailAddress}{" "}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>None</>
                                          )}
                                        </div>
                                      </Col>{" "}
                                      <Col lg={6}>
                                        <div>
                                          {" "}
                                          <span className={"fw-bold"}>
                                            Phone List:
                                          </span>{" "}
                                        </div>
                                        <div>
                                          {!isEmpty(
                                            customerDetails
                                              ?.contacttelephonenumber_data[0]
                                              ?.TelephoneNumber
                                          ) ? (
                                            <>
                                              {customerDetails.contacttelephonenumber_data?.map(
                                                (item, index) => {
                                                  return (
                                                    <div key={index}>
                                                      {item.TelephoneNumber}{" "}
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>None</>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                  <hr />
                                  {/* Change #100301 */}
                                  {!isEditCustomer && (
                                    <div className={"pb-2"}>
                                      <span className={"fw-bold"}>People:</span>{" "}
                                      {wizardPeople.filter(wizardPersonHasName).length ? (
                                        wizardPeople
                                          .filter(wizardPersonHasName)
                                          .map((person) => (
                                            <div key={person.key}>
                                              {`${person.FirstName} ${person.LastName}`.trim()}
                                              {person.JobTitle ? ` - ${person.JobTitle}` : ""}
                                              {person.EmailAddress ? (
                                                <span className="text-muted"> {person.EmailAddress}</span>
                                              ) : null}
                                            </div>
                                          ))
                                      ) : (
                                        <>None</>
                                      )}
                                    </div>
                                  )}
                                </Card>
                              </div>
                              <div
                                className={"  pt-4 d-flex justify-content-end"}
                              >
                                {loading || creatingPeople ? (
                                  <LoadingSpinner size={"small"} row={true} />
                                ) : (
                                  <div className={"d-flex"}>
                                    <span
                                      onClick={() => {
                                        //    updateCustomer();
                                        isEditCustomer
                                          ? handleEditCustomer()
                                          : onCustomerCreated
                                          ? handleCreateCustomer()
                                          : handleCreateCustomer("view");
                                      }}
                                      className={
                                        isEditCustomer || onCustomerCreated
                                          ? "btn btn-success"
                                          : "btn btn-success button-suffix-border-radius"
                                      }
                                    >
                                      {isEditCustomer
                                        ? "Update"
                                        : onCustomerCreated
                                        ? "Create & Select"
                                        : "Create & Open"}
                                    </span>
                                    {!isEditCustomer && !onCustomerCreated && (
                                      <UncontrolledDropdown>
                                        <DropdownToggle
                                          className={
                                            " m-0 p-0  bg-transparent border-0"
                                          }
                                        >
                                          <span
                                            className={
                                              "button-prefix-border-radius btn btn-success"
                                            }
                                          >
                                            <i className="fa-solid fa-caret-down"></i>
                                          </span>
                                        </DropdownToggle>
                                        <DropdownMenu
                                          container="body"
                                          style={{ zIndex: "var(--z-app-menu, 1350)" }}
                                        >
                                          <DropdownItem
                                            onClick={() =>
                                              handleCreateCustomer()
                                            }
                                          >
                                            Create Only
                                          </DropdownItem>
                                          <DropdownItem
                                            id={
                                              "zbtn_customer_createandopen_01"
                                            }
                                            onClick={() => {
                                              handleCreateCustomer("view");
                                            }}
                                          >
                                            Create and Open
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    )}
                                  </div>
                                )}

                                {/*<span*/}
                                {/*  onClick={() => {*/}
                                {/*    setModalCreateCustomer(false);*/}
                                {/*    setIsEditCustomer(false);*/}
                                {/*  }}*/}
                                {/*  className={"btn btn-soft-danger"}*/}
                                {/*>*/}
                                {/*  Close*/}
                                {/*</span>*/}
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </AppModal>
    </>
  );
}
